import {NavLink} from 'react-router-dom';
import {FlagFilled} from '@ant-design/icons';
import {Button, Tag, theme, Typography} from 'antd';
import {ColumnsType} from 'antd/es/table';
import {t} from 'i18next';
import {AppRoutePaths} from 'routing/Routes';
import {ServiceActionListDto, ServiceStatus} from '../../../../../../PRMGApiClient';
import {DateFilterDropdown, DatetimeColumn, getStatusColor} from './ServicesUtils';

const token = theme.defaultConfig.token;

export const serviceActionsColumns: ColumnsType<ServiceActionListDto> = [
  {
    title: t('Service name'),
    dataIndex: 'name',
    key: 'name',
    filters: [{text: 'Required', value: true}],
    render: (text, record) => (
      <Button type="link" className="p-0">
        <NavLink to={`${AppRoutePaths.services.url}/${record.id}`}>
          {text} {record.required && <FlagFilled style={{color: token.red}} />}
        </NavLink>
      </Button>
    ),
  },
  {
    title: t('Car'),
    dataIndex: 'carName',
    key: 'carName',
    sorter: true,
  },
  {
    title: t('Plate number'),
    dataIndex: 'carPlate',
    key: 'carPlate',
    render: (text) => <Typography.Text strong>{text}</Typography.Text>,
  },
  {
    title: t('Start date'),
    key: 'startDateTime',
    dataIndex: 'startDateTime',
    sorter: true,
    render: DatetimeColumn,
    filterDropdown: (props) => <DateFilterDropdown dataIndex="startDateTime" {...props} />,
  },
  {
    title: t('End date'),
    key: 'endDateTime',
    dataIndex: 'endDateTime',
    sorter: true,
    render: DatetimeColumn,
    filterDropdown: (props) => <DateFilterDropdown dataIndex="endDateTime" {...props} />,
  },
  {
    title: t('Status'),
    key: 'status',
    dataIndex: 'status',
    filters: Object.keys(ServiceStatus).map((key) => ({text: key, value: key})),
    sorter: true,
    render: (text) => <Tag color={getStatusColor(text)}>{text}</Tag>,
  },
];
